module.exports = __webpack_public_path__ + "static/media/large_ship.226be300.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameSpacePort/large_ship.png
// module id = 2478
// module chunks = 0